module.exports = __webpack_public_path__ + "static/media/11.6066ad24.svg";